import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import useModels, { maxRes } from "@/lib/useModels";

let toolsCache = null;
const loadTools = () => (toolsCache ||= api.get("/bfx/tools").then((r) => r.data.tools || []).catch(() => { toolsCache = null; return []; }));

const specsOf = (m) => {
  const c = m.capabilities || {};
  const d = c.duration_seconds;
  return [maxRes(m) && `up to ${maxRes(m)}`, d && `${d.min}–${d.max}s`, c.image_edit && "edits images", c.max_images > 1 && `${c.max_images} per run`].filter(Boolean).join(" · ");
};

// Hover dropdown under a top-nav tab listing every model (or BFX tool) of that section.
export default function NavModelMenu({ section, projectId, children }) {
  const nav = useNavigate();
  const models = useModels();
  const [tools, setTools] = useState([]);
  const [shut, setShut] = useState(false);
  useEffect(() => { if (section === "blackfx") loadTools().then(setTools); }, [section]);
  const list = section === "blackfx"
    ? tools.map((t) => ({ id: t.id, name: t.name, description: t.tagline, specs: t.ready === false || t.coming_soon ? "Coming Soon" : t.max_video ? `video up to ${t.max_video}s` : "", available: t.ready !== false }))
    : models.filter((m) => m.section === section).map((m) => ({ id: m.id, name: m.name, description: m.description, specs: specsOf(m), available: m.available }));

  return (
    <div className="relative group/nav" data-testid={`nav-menu-${section}`} onMouseLeave={() => setShut(false)}>
      {children}
      {!!list.length && !shut && (
        <div className="absolute left-0 top-full pt-2 z-[60] hidden group-hover/nav:block">
          <div className="w-[380px] max-h-[70vh] overflow-y-auto rounded-xl border border-zinc-800 bg-[#0E1114]/95 backdrop-blur-xl shadow-2xl p-1.5" data-testid={`nav-menu-list-${section}`}>
            {list.map((m) => (
              <button key={m.id} type="button" onClick={() => { setShut(true); nav(`/studio/${projectId}/${section}?model=${encodeURIComponent(m.id)}`); }}
                data-testid={`nav-menu-item-${m.id}`}
                className={`w-full text-left px-3 py-2 rounded-lg hover:bg-white/5 transition-colors ${m.available ? "" : "opacity-50"}`}>
                <div className="text-sm text-white font-medium">{m.name}</div>
                {m.description && <div className="text-[11px] text-zinc-400 line-clamp-1">{m.description}</div>}
                {m.specs && <div className="text-[10px] font-mono text-[#64b7f6] mt-0.5">{m.specs}</div>}
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
